<template>
  <div class="baseCheckBox">
    <label class="baseCheckBox__wrap">
      <input
        :name="name"
        v-validate="validation"
        type="checkbox"
        class="baseCheckBox__input"
        v-model="isCheckedVal"
        @change="onUpdate"
      />
      <span class="baseCheckBox__label">
        {{ label }}
        <slot></slot>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'baseCheckBox',
  inject: ['$validator'],
  data(){
    return {
      isCheckedVal: false
    }
  },
  props: {
    value: {
      type: String | Number,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true,
      default: undefined
    },
    validation: {
      type: [String, Object],
      default: ''
    },
    isChecked:{
      type: Boolean,
      default: false
    }
  },
  created() {
    this.isCheckedVal = this.isChecked
  },
  mounted(){
    window.addEventListener('pageshow', () => {
      this.isCheckedVal = false
    })
  },
  methods: {
    onUpdate(e) {
      if (e) {
        this.$emit('change', e.target)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

.baseCheckBox {
  $root: &;
  display: flex;
  flex-wrap: wrap;

  &__wrap {
    display: flex;
    align-items: center;
    border-radius: 100%;
    cursor: pointer;
  }
  &__label {
    font-size: 13px;
    line-height: 20px;
    cursor: pointer;
    position: relative;
    display: flex;
    padding-left: 30px;
    color: $col_base_black;
  }
  &__input {
    display: none;
  }
  &__label:before {
    content: '';
    display: block;
    height: 20px;
    width: 20px;
    // background: $col_white;
    border: 1px solid $col_gray;
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 1px;
  }
  &__label:after {
    content: '';
    display: block;
    transform: rotate(45deg);
    border: solid 1.5px $col_white;
    border-top: 0;
    border-left: 0;
    width: 6px;
    height: 11px;
    left: 7px;
    top: -5px;
    position: absolute;
    box-sizing: border-box;
    transition: 0.2s ease-in-out;
    opacity: 0;
  }
  &__input:checked + #{$root}__label {
    &:before {
      background: $col_temp_key1;
      border: none;
    }
    &:after {
      transform: rotate(45deg);
      top: 9px;
      transform: translateY(-50%) rotate(45deg);
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/partials/BaseCheckbox.vue